import React from 'react'
import { Link } from 'react-router-dom'
import Image from "../../images/main_header.png";

function Header() {
  return (
    <div>
        <header className='min__header'>
          <div className="container header__container">
            <div className="header__left">
              <h4>#100DaysOfWorkOut</h4>
              <h1>Join the legends of The fitness world</h1>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea, magnam necessitatibus odit architecto consectetur eligendi, odio voluptatem cum eum, cumque similique? Quisquam velit voluptatem optio quod ratione tempora asperiores inventore!
              </p>
              <Link to="/plans" className='btn lg'>get started</Link>
            </div>
            <div className="header__right">
              <div className="header__circle">
                <div className="header__image">
                  <img src={Image} alt="image" />
                </div>
              </div>
            </div>
          </div>
        </header>
    </div>
  )
}

export default Header